import React from "react";
import PropTypes from "prop-types";
import { Navigate, Outlet } from "react-router-dom";
import { configConstants } from "../_constants";
import { utilityHelper } from "../_helpers";

const TPARoute = ({ authenticated }) => {
    const userInfo = utilityHelper.getUserInfo();

    if (!userInfo) {
        return <Navigate to="/" replace={true}/>;
    }

    const isAdminOrTPA =
        userInfo.role === configConstants.USER_ROLE_ADMIN ||
        userInfo.role === configConstants.USER_ROLE_TPA;

    return authenticated && isAdminOrTPA ? <Outlet /> : <Navigate to="/" replace={true}/>;
};

TPARoute.propTypes = {
    authenticated: PropTypes.bool.isRequired,
};

export { TPARoute };
